import { useRef, useState } from "react";

const useCarouselSimple = (length: number) => {
    const [index, setIndex] = useState<number>(0);
    const touchStartX = useRef<number>(0);
    const touchEndX = useRef<number>(0);

    const prev = () => setIndex((i) => (i === 0 ? length - 1 : i - 1));
    const next = () => setIndex((i) => (i === length - 1 ? 0 : i + 1));

    const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
        touchStartX.current = e.touches[0].clientX;
    };
    const handleTouchMove = (e: React.TouchEvent<HTMLDivElement>) => {
        touchEndX.current = e.touches[0].clientX;
    };
    const handleTouchEnd = () => {
        const diff = touchStartX.current - touchEndX.current;
        if (diff > 50) next();
        else if (diff < -50) prev();
        touchStartX.current = 0;
        touchEndX.current = 0;
    };

    return { index, setIndex, prev, next, handleTouchStart, handleTouchMove, handleTouchEnd };
};

export default useCarouselSimple;